import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list of all the people
  login: (payload) => client.post(apiList.loginApi, { json: payload }),
  rule: () => client.get(apiList.getRuleAndRegulation),
  changePassword: (payload) => client.post(apiList.changePassword, { json: payload }),
};